import { ProgressBar } from "@/design-system/ProgressBar/ProgressBar";
import { SolutionTags } from "@/pages/Sbcs/components/Alternatives/SolutionTags";
import { SummaryFigures } from "@/pages/Sbcs/components/SummaryFigures";
import { StreamlineTotals } from "@repo/shared/streamline";
import { StreamlineSolution } from "@repo/shared/types";
import { ReactNode } from "react";

import { AddPlayerButton } from "./AddPlayerButton";
import { PointsCounter } from "./PointsCounter";

/**
 * Mobile: the same band as a normal SBC solution (actions, figures, tags),
 * then the progress line, which sticks to the viewport top. The back arrow
 * and set name come from the app's persistent top nav.
 */
export const StreamlineMobileHeader = ({
  actions,
  totals,
  solution,
  minPoints,
  onCommitProgress,
  onAddPlayer,
  addedCount = 0,
  loading = false,
}: {
  /** The compact SolutionActions row. */
  actions: ReactNode;
  totals: StreamlineTotals;
  solution: StreamlineSolution;
  minPoints: number;
  onCommitProgress: (points: number) => void;
  onAddPlayer: () => void;
  addedCount?: number;
  loading?: boolean;
}) => (
  <>
    <div className="relative z-20 flex flex-col gap-2.5 border-b border-edge-strong bg-surface px-4 py-2.5">
      {actions}
      <div className="h-px bg-edge-strong" />
      <SummaryFigures facts={totals} compact loading={loading} />
      <SolutionTags
        tags={solution.tags}
        recommended={solution.isRecommended}
        loading={loading}
      />
    </div>
    <div className="sticky top-0 z-30 flex items-center gap-3 bg-background px-4.5 py-3">
      <ProgressBar ratio={totals.progress} small className="min-w-0 flex-1" />
      <PointsCounter
        earned={totals.pointsEarned}
        target={totals.targetPoints}
        small
        min={minPoints}
        onCommitProgress={onCommitProgress}
        loading={loading}
      />
      <AddPlayerButton
        onClick={onAddPlayer}
        count={addedCount}
        disabled={loading}
        compact
      />
    </div>
  </>
);
